import API from '../../api/api';
import utils from '../../../modules/utils';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'WECHATPAY';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE' || status === 'FAILURE');
}

function returnedFromHostedPage(queryParams = '') {
  const {status} = utils.fn.getURIParams(queryParams);
  
  // potentially needs to change after asserting how h5 hosted redirect works
  if (status && status.toUpperCase() === 'SUCCESS') {
    return API.handleWeChatSessionUpdate('paymentSuccess');
  }
  
  return Promise.reject();
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
